import { combineReducers } from 'redux';
import user, { initialState as userInitialState } from './user/reducer';

export const initialState = {
  user: userInitialState,
};

export default combineReducers({ user });
